import React, { useState } from 'react';

import { Container } from './styles';

type AccordionProps = {
  controllerComponent: React.ReactNode
  children: React.ReactNode,
}

export const Accordion = ({ children, controllerComponent }: AccordionProps) => {

  const [isOpen, setIsOpen] = useState(false);


  return <Container isOpen={isOpen}>
    <header onClick={() => setIsOpen(!isOpen)}>
      {controllerComponent}
    </header>
    <section>
      {children}
    </section>
  </Container>
}